export default "__VITE_ASSET__CKW0X2x8__"